export const password = { required: true, max: 64, min: 8 };
